<template>
  <div class="configure-splash-container">
    <div class="splash-header-row">
      <div class="splash-header-col">
        <h4>Configure Splash Screen</h4>
      </div>
      <div class="splash-header-col splash-preview-heading-col">
        <h4>Theme Preview</h4>
      </div>
    </div>
    <div class="splash-form-row">
      <div class="splash-form-col">
        <label class="splash-label">Splash Screen BG Image</label>
        <div>
          <single-image
            :id="'splashIcon'"
            :url="splashIcon"
            @change="(val) => $emit('update-splash-icon', val)"
            height="200px"
            width="100%"
            :label="'Drag and drop or click to upload'"
            class="splash-image-upload"
          />
        </div>
        <label class="mt-4 splash-label">Background Color</label>
        <div>
          <color-picker
            colorRef="splash-col"
            colorId="splash-col"
            defaultValue="#ffffff"
            label="Splash Background"
            @change="(val) => (splashBGCol = val)"
            ref="splash-bg-colour"
            class="mb-4"
          ></color-picker>
        </div>
      </div>
      <div class="splash-preview-col">
        <div class="splash-preview-area">
          <div class="mobile-preview-wrapper">
            <mobile-view
              screen="splash"
              :bg-image="splashBGImage"
              :bg-color="splashBGCol"
              class="ml-8"
              :splash-b-g-image="splashBGImage"
              :splash-b-g-col="splashBGCol"
              :splash-icon="splashIcon"
            />
          </div>
        </div>
      </div>
    </div>
    <slot name="footer-button" :data="SplashData"></slot>
  </div>
</template>

<script>
import SingleImage from "@/components/Common/Image.vue";
import ColorPicker from "@/components/FormElements/ColorPicker.vue";
import mobileView from "@/views/profile/mobileView.vue";

export default {
  name: "ConfigureSplashScreen",
  data() {
    return {
      splashBGImage: null,
      splashBGCol: "#ffffff",
    };
  },
  computed: {
    SplashData() {
      return {
        splashBGCol: this.splashBGCol,
      };
    },
  },
  components: {
    SingleImage,
    ColorPicker,
    mobileView,
  },
  props: {
    splashIcon: { type: String, default: "" },
  },
};
</script>

<style scoped>
.configure-splash-container {
  border: 1px solid #e3eaef;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  width: 100%
}
.splash-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 0.5rem;
}
.splash-header-col {
  flex: 1;
  display: flex;
  align-items: flex-end;
}
.splash-preview-heading-col {
  justify-content: flex-start;
}
.splash-form-row {
  display: flex;
  gap: 32px;
  align-items: flex-start;
}
.splash-form-col {
  width: 50%;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e3eaef;
  padding: 24px 18px 18px 18px;
  box-sizing: border-box;
  height: 450px;
}
.splash-label {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 8px;
  display: block;
}
.splash-upload-box {
  border: 2px dashed #bdbdbd;
  border-radius: 8px;
  padding: 24px 0;
  background: #fafbfc;
  margin-bottom: 18px;
  text-align: center;
}
.splash-bg-color-picker {
  width: 180px;
}
.splash-preview-col {
  width: 50%;
  background: #fafbfc;
  border-radius: 8px;
  border: 1px solid #e3eaef;
  padding: 24px 18px 18px 18px;
  display: flex;
  flex-direction: column;
  height: 450px;
  align-items: center;
  box-sizing: border-box;
}
.splash-preview-area {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* min-height: 260px; */
  /* background: #f3f3f3; */
  /* border-radius: 8px; */
}
.mobile-preview-wrapper {
  max-width: 200px;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  transform: scale(0.75);
  transform-origin: top center;
}
@media (max-width: 900px) {
  .splash-header-row {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }
  .splash-form-row {
    flex-direction: column;
    gap: 22px;
  }
  .splash-form-col,
  .splash-preview-col {
    max-width: 100%;
  }
}
</style>
